<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title class="body-1">
        <a @click="toBack">Ticket</a>
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.ticket_details }}
        <v-icon>mdi-chevron-right</v-icon> 
        {{this.ticketID}}
      </v-card-title>
    </v-card>

    <!-- ticket info -->
    <v-card>
      <v-card-title>
        <span>{{ticketInfo.typeName}}</span>
        <v-spacer />
        <span>{{formatDatetime(ticketInfo.ticket.created)}}</span>
      </v-card-title>
      <v-card-title class="pt-0">
        <span>{{ use_language.ticket_subject }} : {{ticketInfo.ticket.ticketName}}</span>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.menu_orders }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <span class="fn-13">
              <a @click="ShowDetailOrder(ticketInfo.ticket.orderID)">
                {{FormatOrder(ticketInfo.ticket.orderID)}}
              </a>
            </span>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.details }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <span class="fn-13 color-black">{{ ticketInfo.ticket.description }}</span>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row v-if="ticketInfo.branchName">
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.notify_warehouse }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <span class="fn-13 color-black">{{ ticketInfo.branchName }}</span>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>

        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.status }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <v-autocomplete 
              v-model="statusSelect" :placeholder="use_language.select_status" :items="statusList"
              item-text="statusName" item-value="statusID" outlined required hide-details dense
              ref="updateStatusSelect"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.assign }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <div v-if="this.staffSelect != 0">
              <v-autocomplete 
                v-model="staffSelect" :placeholder="use_language.select_employee" :items="staffList"
                item-text="name" item-value="id" outlined required hide-details dense
                ref="updateStaffSelect"
              >
              </v-autocomplete>
            </div>
            <div v-else-if="ticketInfo.ticket.toBranchID != null" style="color: red">{{ use_language.to_warehouse }}</div>
            <div v-else style="color: red">{{ use_language.to_support }}</div>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.related_persons }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <span class="fn-13 color-black">{{ ticketInfo.relateText.slice(3) }}</span>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row>
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.create_by }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <span class="fn-13 color-black">{{ staffList.filter(x => x.id == ticketInfo.ticket.createdBy)[0].name }}</span>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row v-if="ticketInfo.file.length > 0">
          <v-col cols="4" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.file }} :</span>
          </v-col>
          <v-col cols="8" md="4" class="pt-1 pb-2">
            <v-data-table
              :headers="fileMainHeader"
              :items="ticketInfo.file"
              :items-per-page="9999999999"
              hide-default-footer
              class="packhai-border-table"
            >
              <template v-slot:item.fileID="{ item }">
                {{ticketInfo.file.findIndex(x => x.fileID == item.fileID) + 1}}
              </template>
              <template v-slot:item.fileUrl="{ item }">
                <a 
                  v-if="item.fileUrl.substr(item.fileUrl.length - 3) == 'jpg' || item.fileUrl.substr(item.fileUrl.length - 3) == 'png'" 
                  @click="OpenPhoto(item.fileUrl)"
                >
                  <img :src="item.fileUrl" class="picsize mt-1">
                </a>
                <a v-else :href="item.fileUrl" target="_blank">{{ use_language.file }}</a>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" md="5" />
        </v-row>
        <v-row class="pt-2">
          <div></div>
          <v-spacer/>
          <div class="pr-3">
            <v-btn dark :elevation="1" color="primary" class="text-right" @click="updateTicket()">
              <v-icon left>mdi-content-save</v-icon>
              {{ use_language.button_save }}
            </v-btn>
          </div>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="py-2">
      <v-btn dark :elevation="1" color="primary" class="text-right" @click="dialogReply.dialog = true">
        <v-icon left>fa-plus</v-icon>
        {{ use_language.add_detail }}
      </v-btn>
    </div>

    <!-- ticket reply -->
    <v-card v-for="(itemMain, index) in ticketReply" :key="index" class="mb-4">
      <v-card-title>
        <span v-if="itemMain.isSupport == true" style="color: red">{{ use_language.from_support }}</span>
        <span v-else-if="itemMain.isWarehouse == true" style="color: red">{{ use_language.from_warehouse }}</span>
        <span v-else>{{itemMain.staffName}}</span>
        <v-spacer />
        <span>{{itemMain.created}}</span>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="3" md="2" lg="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.details }} :</span>
          </v-col>
          <v-col cols="8" md="" lg="8" class="pt-1 pb-2">
            <div v-if="replyEdit.isEdit == true && replyEdit.replyID == itemMain.replyID" class="pb-4">
              <v-textarea
                :value="replyEdit.description"
                @change="value => replyEdit.description = Trim_value(value)"
                ref="replyEdit"
                autocomplete="off"
                outlined
                dense hide-details
                rows="3"
                row-height="9999"
              />
              <v-btn
                onclick="document.getElementById('fileInput').click()"
                outlined
                color="primary"
                class="mt-2"
              >
                {{ use_language.attach_file }}
              </v-btn>
              <v-file-input
                id="fileInput"
                v-model="myFile"
                @change="setDataFile()"
                style="display: none"
              />
              <v-row>
                <v-col v-for="(item,index) in preFile" :key="index" class="col-3">
                  <div class="d-flex">
                    <v-img v-if="item.type == 'image/jpeg' || item.type == 'image/png'" class="mt-3 title mb-1" :src="item.url"/>
                    <v-icon v-else size="120" class="mt-3 mb-1" color="teal darken-3">fa fa-file-alt</v-icon>
                    <v-btn icon color="danger" @click="removeFile(item)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <div class="pt-1">
                <v-btn dark color="primary" class="mr-1" small @click="editTicketReply()">
                  {{ use_language.button_save }}
                </v-btn>
                <v-btn dark color="danger" small @click="setEditReply(0)">
                  {{ use_language.cancel }}
                </v-btn>
              </div>
            </div>
            <span v-else class="fn-13 color-black">{{itemMain.description}}</span>
          </v-col>
          <v-col v-if="itemMain.isWarehouse == false && itemMain.staffID == staffID" cols="1" md="2" lg="2" class="text-right">
            <a @click="setEditReply(1, itemMain)">
              <v-icon size="16" color="primary darken-3">fa-edit</v-icon>
            </a>
          </v-col>
        </v-row>
        <v-row v-if="itemMain.fileList.length > 0">
          <v-col cols="3" md="2" class="pt-1 pb-2">
            <span class="fn-13">{{ use_language.file }} :</span>
          </v-col>
          <v-col cols="9" md="6" class="pt-1 pb-2">
            <v-data-table
              :headers="(itemMain.isWarehouse == false && itemMain.staffID == staffID) ? fileReplyHeader : fileHeader"
              :items="itemMain.fileList"
              :items-per-page="9999999999"
              hide-default-footer
              class="packhai-border-table"
            >
              <template v-slot:item.replyID="{ item }">
                {{itemMain.fileList.findIndex(x => x.fileID == item.fileID) + 1}}
              </template>
              <template v-slot:item.fileUrl="{ item }">
                <a 
                  v-if="item.fileUrl.substr(item.fileUrl.length - 3) == 'jpg' || item.fileUrl.substr(item.fileUrl.length - 3) == 'png'" 
                  @click="OpenPhoto(item.fileUrl)"
                >
                  <img :src="item.fileUrl" class="picsize mt-1">
                </a>
                <a v-else :href="item.fileUrl" target="_blank">{{ use_language.file }}</a>
              </template>
              <template v-slot:item.fileID="{ item }">
                 <a @click="removeReplyFile(item)">
                  <v-icon size="16" color="red darken-3">fa-trash</v-icon>
                </a>
              </template>
            </v-data-table>

          </v-col>
          <v-col cols="12" md="5"/>
        </v-row>
        <v-row v-if="itemMain.updated != null || itemMain.staffID == staffID" class="pt-2" align="center">
          <v-col v-if="itemMain.updated != null">
            <small>{{ use_language.last_edited }} {{itemMain.updated}}</small>
          </v-col>
          <v-col v-if="itemMain.isWarehouse == false && itemMain.staffID == staffID" class="text-right">
            <v-btn dark color="danger" @click="removeTicketReply(itemMain.replyID)">
              <v-icon left>fa-trash</v-icon>
              {{ use_language.delete }}
            </v-btn>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <!-- add reply -->
    <v-dialog v-model="dialogReply.dialog" scrollable max-width="50%" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1" class="ma-0">
        <v-card-title>
          <v-icon size="22" color="teal darken-3">fa fa-file-signature</v-icon>
           <span class="ml-3">{{ use_language.add_detail }}</span>
          <v-spacer/>
          <v-btn icon @click="closeDialogReply()"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-y-auto px-5">
          <v-row>
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14"> {{ use_language.details }} : </span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-textarea
                :value="dialogReply.description"
                @change="value => dialogReply.description = Trim_value(value)"
                ref="dialogReply"
                autocomplete="off"
                outlined
                dense hide-details
                rows="3"
                row-height="9999"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" class="pt-1 pb-2">
              <span class="fn-14"> {{ use_language.attach_file_image }} : </span>
            </v-col>
            <v-col cols="12" md="9" class="pt-1 pb-2">
              <v-btn
                onclick="document.getElementById('fileInput').click()"
                outlined
                color="primary"
              >
                {{ use_language.attach_file }}
              </v-btn>
              <v-file-input
                id="fileInput"
                v-model="myFile"
                @change="setDataFile()"
                style="display: none"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="(item,index) in preFile" :key="index" class="col-3">
              <div class="d-flex">
                <v-img v-if="item.type == 'image/jpeg' || item.type == 'image/png'" class="mt-3 title mb-1" :src="item.url"/>
                <v-icon v-else size="120" class="mt-3 mb-1" color="teal darken-3">fa fa-file-alt</v-icon>
                <v-btn icon color="danger" @click="removeFile(item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-row  class="item-center">
            <v-col align="right">
              <v-btn :elevation="1" color="primary" @click="createTicketReply()">
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="fn-14"><b> {{ use_language.button_save }} </b></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- show photo -->
    <v-dialog v-model="ShowPhoto" max-width="600">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="ShowPhotoLink" width="400">
              <img class="hidden-sm-and-down" :src="ShowPhotoLink" width="550">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text color="#1976d2" :href="ShowPhotoLink" target="_blank">
            {{ use_language.open_new_tab }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="ShowPhoto = false">{{ use_language.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2"; 
import Loading from "@/website/components/Loading";
import { AlertSuccess, AlertWarning, AlertError } from "@/website/global_alert";
import { Trim_value, FormatOrder, formatDatetime, get_languages } from "@/website/global_function";
import { shopService_dotnet, branchService_dotnet, generalService_dotnet } from "../../global";

export default {
  name: 'FrontWarehouseTicketDetail',

  components: {
    Loading,
  },

  data() {
    return {
      use_language: {},
      // info for ticket
      ticketID: null,
      shopID: JSON.parse(localStorage.getItem("shop_id")),
      branchID: JSON.parse(localStorage.getItem("branch_id")),
      staffID: JSON.parse(localStorage.getItem("staff_id")),
      header_token: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorization_token"),
      },
  
      // ticket detail
      ticketInfo: null,
      ticketReply: [],

      // update ticket
      statusSelect: null,
      staffSelect: null,
      statusList: [],
      staffList: [],

      // add reply
      dialogReply: {
        dialog: false,
        type: 0,
        name: null,
        description: null,
      },

      replyEdit: {
        isEdit: false,
        replyID: 0,
        description: null
      },

      myFile: null,
      preFile: [],
      insertFile: [],
      ShowPhoto: false,
      ShowPhotoLink: '',

      // loading
      page_loading: true,
      loading: false,
    };
  },

  mounted() {
    
  },

  computed: {
    fileMainHeader() {
      if (!this.use_language) return [];
      return [
        { align: "center", text: "No", value: "fileID", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.file_image, value: "fileUrl", sortable: false, width: "200px" },
      ];
    },
    fileHeader() {
      if (!this.use_language) return [];
      return [
        { align: "center", text: "No", value: "replyID", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.file_image, value: "fileUrl", sortable: false, width: "200px" },
      ];
    },
    fileReplyHeader() {
      if (!this.use_language) return [];
      return [
        { align: "center", text: "No", value: "replyID", sortable: false, width: "60px" },
        { align: "center", text: this.use_language.file_image, value: "fileUrl", sortable: false, width: "200px" },
        { align: "center", text: this.use_language.delete, value: "fileID", sortable: false, width: "60px" },
      ];
    },
  },

  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.ticketID = parseInt(atob(this.$route.query.id));
    await this.getStatus()
    await this.getStaff()
    await this.getTicketDetail()
    await this.getTicketReply()
    this.page_loading = false;
    this.loading = false
    
  },

  methods: {
    get_languages,
    Trim_value,
    FormatOrder,
    formatDatetime,

    toBack() {
      this.$router.push('/ticket')
    },
    ShowDetailOrder(id,) {
      window.open("/order-detail?id=" + id);
    },
    OpenPhoto(Photo) {
      this.ShowPhotoLink = Photo
      this.ShowPhoto = true
    },

    //#region info for ticket
    async getStaff() {
      let response = await axios.post(
        shopService_dotnet + "Shop/get-shop-staff",
        {shopID: this.shopID},
        { headers: this.header_token }
      );
      this.staffList = response.data
    },

    async getStatus() {
      let response = await axios.post(
        shopService_dotnet + "Ticket/get-ticket-status",
        {
          shopID: this.shopID,
        },
        { headers: this.header_token }
      );
      this.statusList = response.data
    },

    setDataFile() {
      if (this.myFile != null) {
        var url = URL.createObjectURL(this.myFile);
        if (this.myFile.type == "image/png" || this.myFile.type == "image/jpeg") {
          this.preFile.push({url: url, name: this.myFile.name, type:this.myFile.type, file: this.myFile})
        } else {
          this.preFile.push({url: url, name: this.myFile.name, type:this.myFile.type, file: this.myFile })
        }
      }
    },

    removeFile(img) {
      this.preFile = this.preFile.filter(function(item) {
        return item !== img
      })
      this.myFile = null
    },

    async uploadFile(file) {
      var form_data = new FormData();
      form_data.append("file", file);
      form_data.append("bucket", "branch/ticket");
      let response = await axios.post(
        generalService_dotnet + "General/upload-file-with-bucket",
        form_data,
        {
          headers: { 
            "Content-Type": "multipart/form-data",
            "Authorization": "Bearer " + localStorage.getItem("authorization_token"),
          },
        }
      );
      if (response.status == 200) {
        this.insertFile.push(response.data.file_path);
      }
    },
    //#endregion info for ticket

    //#region ticket detail
    async getTicketDetail() {
      let response = await axios.post(
        shopService_dotnet + "Ticket/get-ticket-detail",
        {
          ticketID: this.ticketID
        },
        { headers: this.header_token }
      );
      this.ticketInfo = response.data
      this.statusSelect = response.data.ticket.statusID
      this.staffSelect = response.data.ticket.assignTo
    },

    async updateTicket() {
      if(this.statusSelect == null) {
        this.$refs.updateStatusSelect.focus()
        this.errorAlert(this.use_language.please_select_status)
        return
      } else if(this.staffSelect == null) {
        this.$refs.updateStaffSelect.focus()
        this.errorAlert(this.use_language.please_select_employee)
        return
      } 
      let response = await axios.post(
        shopService_dotnet + "Ticket/edit-ticket",
        {
          "ticketID": this.ticketID,
          "statusID": this.statusSelect,
          "assignTo": this.staffSelect,
          "updatedBy": this.staffID,
          "isWarehouse": false,
          "isSupport": false
        },
        { headers: this.header_token }
      );
      if (response.status == 200) {
        await this.getTicketDetail()
        this.successAlert()
      }
    },
    //#endregion ticket detail

    //#region ticket reply
    async getTicketReply() {
      let response = await axios.post(
        shopService_dotnet + "Ticket/get-ticket-reply",
        {
          "ticketID": this.ticketID
        },
        { headers: this.header_token }
      );
      this.ticketReply = response.data
    },

    async createTicketReply() {
      if (this.dialogReply.description == null || this.dialogReply.description == '') {
        this.$refs.dialogReply.focus()
        this.errorAlert(this.use_language.please_enter_detail)
        return
      }
      
      for (let index = 0; index < this.preFile.length; index++) {
        await this.uploadFile(this.preFile[index].file)
      }

      let response = await axios.post(
        shopService_dotnet + "Ticket/create-ticket-reply",
        {
          "ticketID": this.ticketID,
          "staffID": this.staffID,
          "description": this.dialogReply.description,
          "IsWarehouse": false,
          "file": this.insertFile
        },
        { headers: this.header_token }
      );

      if (response.status == 200) {
        await this.getTicketReply()
        this.successAlert()
        this.closeDialogReply()
      }
    },

    async editTicketReply() {
      if (this.replyEdit.description == null || this.replyEdit.description == '') {
        // this.$refs.replyEdit.focus()
        this.errorAlert(this.use_language.please_enter_detail)
        return
      }
      
      for (let index = 0; index < this.preFile.length; index++) {
        await this.uploadFile(this.preFile[index].file)
      }

      let response = await axios.post(
        shopService_dotnet + "Ticket/edit-ticket-reply",
        {
          "replyID": this.replyEdit.replyID,
          "description": this.replyEdit.description,
          "file": this.insertFile
        },
        { headers: this.header_token }
      );

      if (response.status == 200) {
        await this.getTicketReply()
        this.successAlert()
        this.setEditReply(0)
      }
    },

    async removeTicketReply(id) {
      Swal.fire({
        position: "top",
        icon: "warning",
        text: this.use_language.confirm_delete_comment,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.post(
            shopService_dotnet + "Ticket/remove-ticket-reply",
            {
              "replyID": id
            },
            { headers: this.header_token }
          );
          if (response.status == 200) {
            await this.getTicketReply()
            this.successAlert()
          }
        }
      });
    },

    async removeReplyFile(item) {
      Swal.fire({
        position: "top",
        icon: "warning",
        text: this.use_language.confirm_delete_file,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          let response = await axios.post(
            shopService_dotnet + "Ticket/remove-ticket-reply-file",
            {
              "replyID": item.replyID,
              "fileID": item.fileID
            },
            { headers: this.header_token }
          );
          if (response.status == 200) {
            this.successAlert()

            this.ticketReply = this.ticketReply.map((arr) => {
              if (arr.replyID == item.replyID) {
                return {...arr, fileList: arr.fileList.filter(x => x.fileID != item.fileID)};
              }
              return arr;
            });
          }
        }
      });
    },

    setEditReply(type, item) {
      if (type == 1) {
        if (this.replyEdit.isEdit == false) {
          this.replyEdit = {
            isEdit: true,
            replyID: item.replyID,
            description: item.description
          }
        } else {
          this.replyEdit = {
            isEdit: false,
            replyID: null,
            description: null
          }
          this.myFile = null
          this.preFile = []
          this.insertFile = []
        }
      } else {
        this.replyEdit = {
          isEdit: false,
          replyID: null,
          description: null
        }
        this.myFile = null
        this.preFile = []
        this.insertFile = []
      }
    },

    closeDialogReply() {
      this.dialogReply = {
        dialog: false,
        type: 0,
        name: null,
        description: null,
      }
      this.myFile = null
      this.preFile = []
      this.insertFile = []
    },
    //#endregion ticket reply

    //#region alert
    async successAlert(){
      Swal.fire({
        toast: true,
        timer: 1500,
        showConfirmButton: false,
        type: 'success',
        title: 'Success'
      })
    },
    async errorAlert(body){
      Swal.fire({
        type: 'error',
        text: body,
      })
    },
    //#endregion alert
  },
};
</script>

<style scoped>

</style>